import { render, staticRenderFns } from "./ListData.vue?vue&type=template&id=3bc162b2&"
import script from "./ListData.vue?vue&type=script&lang=js&"
export * from "./ListData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports